export default "__VITE_PUBLIC_ASSET__23af12c7__"